/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrUpdateTimecardBreakDefinition} from '../api'

export const useMutationCreateOrUpdateTimecardBreakDefinition = createReactQueryMutationHook('createOrUpdateTimecardBreakDefinition', createOrUpdateTimecardBreakDefinition)
